import { render, staticRenderFns } from "./vTile.vue?vue&type=template&id=005f0889&scoped=true&"
import script from "./vTile.vue?vue&type=script&lang=js&"
export * from "./vTile.vue?vue&type=script&lang=js&"
import style0 from "./vTile.vue?vue&type=style&index=0&id=005f0889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f0889",
  null
  
)

export default component.exports